<template>
  <div class="base">
    <div class="map-options">
      <div class="left">
        <a-tabs default-active-key="1" @change="callbackType">
          <a-tab-pane key="1" :tab="$t('moduleTitles.pcpublish')"></a-tab-pane>
          <a-tab-pane key="2" :tab="$t('charts.views')"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="right">
        <div style="margin-right: 10px">
          <a-tabs default-active-key="1" @change="callbackDate">
            <a-tab-pane key="1" :tab="$t('charts.dateRange.today')"></a-tab-pane>
            <a-tab-pane key="2" :tab="$t('charts.dateRange.week')"></a-tab-pane>
            <a-tab-pane key="3" :tab="$t('charts.dateRange.month')"></a-tab-pane>
            <a-tab-pane key="4" :tab="$t('charts.dateRange.year')"></a-tab-pane>
          </a-tabs>
        </div>
        <div style="margin-right:10px;display: flex;align-items: center;">
          <a-range-picker @change="onDateChange">
            <a-icon slot="suffixIcon" type="smile" />
          </a-range-picker>
          <!-- <br /> -->
          <div class="export" v-if="isexport">
            <a-button type="primary" @click="exportMap" icon="export">{{$t('charts.dateRange.export')}}</a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="isloading">
      <a-spin :spinning="isloading"></a-spin>
    </div>
    <!-- <div class="map-container" id="only-map"></div> -->
  </div>
</template>

<script>
import { Scene } from "@antv/l7";
import { CountryLayer } from "@antv/l7-district";
import { Mapbox } from "@antv/l7-maps";
import {
  getWorkProvinceStatist,
  getVisitProvinceStatist,
} from "@/api/statistic";
import {
  getDateStr,
  getThisWeekMonDayStr,
  getThisMonthFirstDayStr,
  getThisYearFirstDayStr,
} from "@/utils/tools";

export default {
  props: {
    isexport: { default: false, type: Boolean },
    newData: {},
  },
  data() {
    return {
      ProvinceData: [
        {
          province_name: this.$t('charts.province.yunnan'),
          province: 530000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.heilongjiang'),
          province: 230000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guizhou'),
          province: 520000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.beijing'),
          province: 110000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hebei'),
          province: 130000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanxi'),
          province: 140000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jilin'),
          province: 220000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.ningxiahuizu'),
          province: 640000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.liaoning'),
          province: 210000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hainan'),
          province: 460000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.neimenggu'),
          province: 150000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.tianjin'),
          province: 120000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xinjiang'),
          province: 650000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanghai'),
          province: 310000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanxisheng'),
          province: 610000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.gansu'),
          province: 620000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.anhui'),
          province: 340000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xianggang'),
          province: 810000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guangdong'),
          province: 440000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.henan'),
          province: 410000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hunan'),
          province: 430000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jiangxi'),
          province: 360000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.sichuan'),
          province: 510000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guangxi'),
          province: 450000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jiangsu'),
          province: 320000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.aomen'),
          province: 820000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.zhejiang'),
          province: 330000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shandong'),
          province: 370000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.qinghai'),
          province: 630000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.chongqing'),
          province: 500000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.fujian'),
          province: 350000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hubei'),
          province: 420000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xizang'),
          province: 540000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.taiwan'),
          province: 710000,
          value: 0,
        },
      ],
      tempData: [
        {
          province_name: this.$t('charts.province.yunnan'),
          province: 530000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.heilongjiang'),
          province: 230000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guizhou'),
          province: 520000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.beijing'),
          province: 110000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hebei'),
          province: 130000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanxi'),
          province: 140000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jilin'),
          province: 220000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.ningxiahuizu'),
          province: 640000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.liaoning'),
          province: 210000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hainan'),
          province: 460000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.neimenggu'),
          province: 150000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.tianjin'),
          province: 120000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xinjiang'),
          province: 650000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanghai'),
          province: 310000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shanxisheng'),
          province: 610000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.gansu'),
          province: 620000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.anhui'),
          province: 340000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xianggang'),
          province: 810000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guangdong'),
          province: 440000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.henan'),
          province: 410000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hunan'),
          province: 430000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jiangxi'),
          province: 360000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.sichuan'),
          province: 510000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.guangxi'),
          province: 450000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.jiangsu'),
          province: 320000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.aomen'),
          province: 820000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.zhejiang'),
          province: 330000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.shandong'),
          province: 370000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.qinghai'),
          province: 630000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.chongqing'),
          province: 500000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.fujian'),
          province: 350000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.hubei'),
          province: 420000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.xizang'),
          province: 540000,
          value: 0,
        },
        {
          province_name: this.$t('charts.province.taiwan'),
          province: 710000,
          value: 0,
        },
      ],
      scene: null,
      countryLayer: null,
      isloading: true,
      beginDate: getDateStr(),
      endDate: getDateStr(),
      currentType: "work",
    };
  },
  created() {
    this.handleUserSelect();
  },

  mounted() {
    // this.initMap();
  },

  methods: {
    getVisitDataBy(data) {
      // 獲取地圖數據
      getVisitProvinceStatist(data)
        .then((res) => {
          if (res.data) {
            this.updateMapData(res.data);
          }
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },
    getWorkDataBy(data) {
      getWorkProvinceStatist(data)
        .then((res) => {
          if (res.data) {
            this.updateMapData(res.data);
          }
        })
        .catch((err) => {
          // this.$message.error(err);
        });
    },
    callbackDate(index) {
      if (index === "1") {
        // 今天
        this.beginDate = getDateStr();
      } else if (index === "2") {
        // 本周
        this.beginDate = getThisWeekMonDayStr();
      } else if (index === "3") {
        //本月
        this.beginDate = getThisMonthFirstDayStr();
      } else if (index === "4") {
        //本年
        this.beginDate = getThisYearFirstDayStr();
      }
      this.handleUserSelect();
    },

    callbackType(index) {
      if (index === "2") {
        this.currentType = "visit";
      } else {
        this.currentType = "work";
      }
      this.handleUserSelect();
    },

    handleUserSelect() {
      this.removeMap();
      this.isloading = true;
      if (this.currentType == "visit") {
        this.getVisitDataBy({
          beginDate: this.beginDate,
          endDate: this.endDate,
        });
      } else {
        this.getWorkDataBy({
          beginDate: this.beginDate,
          endDate: this.endDate,
        });
      }
    },

    onDateChange(date, dateString) {
      this.getVisitDataBy({
        beginDate: dateString[0],
        endDate: dateString[1],
      });
      console.log('date string', dateString);
    },

    exportMap() {
      const file = this.scene.exportMap("png");
    },
    updateMapData(data) {
      if (data.length > 0) {
        const key = this.currentType === "visit" ? "visit_count" : "work_count";
        for (let i = 0; i < this.ProvinceData.length; i++) {
          const item = this.ProvinceData[i];
          for (let j = 0; j < data.length; j++) {
            // 服務器給的數組
            const serveData = data[j];
            if (+serveData.province === item.province) {
              item.value = +serveData[key];
            }
          }
        }
      } else {
        this.ProvinceData = this.$deepClone(this.tempData);
      }
      this.reRenderMap();
    },

    reRenderMap() {
      this.removeMap();
      this.initMap();
    },

    initMap() {
      this.isloading = false
      this.scene = new Scene({
        id: "only-map",
        logoVisible: false,
        map: new Mapbox({
          // center: [116.2825, 39.9],
          // center: [105.3201, 40.8080],
          pitch: 0,
          style: "blank",
          zoom: 3,
          minZoom: 3,
          maxZoom: 3,
        }),
      });

      this.scene.setMapStatus({
        dragEnable: false, //是否允許地圖拖拽
        keyboardEnable: false, // 是否允許形鍵盤事件
        doubleClickZoom: false, // 雙擊放大
        zoomEnable: false, // 滾動縮放
        rotateEnable: false, // 旋轉
      });

      this.countryLayer = new CountryLayer(this.scene, {
        data: this.ProvinceData,
        joinBy: ["NAME_CHN", "province_name", "adcode", "province"],
        depth: 1,
        fill: {
          color: "#ccc",
        },
        bubble: {
          enable: true,
          size: {
            field: "value",
            values: [0, 20],
          },
        },
        popup: {
          enable: true,
          Html: (props) => {
            const count = props.value ? props.value : 0;
            return `<span style="color: #000000;font-size: 12px">${props.NAME_CHN}:</span><span style="color: #000000;font-size: 12px">${count}</span>`;
          },
        },
      });

      this.scene.on("loaded", () => {
        this.countryLayer;
      });
    },

    removeMap() {
      if (this.scene) {
        this.scene.off("loaded");
        this.scene.destroy();
      }
    },
  },

  beforeDestroy() {
    if (this.scene) {
      this.scene.off("loaded");
      this.scene.destroy();
    }
  },
};
</script>

<style scoped>
.base {
  width: 100%;
  height: 100%;
}
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.map-options {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.right {
  display: flex;
  justify-content: flex-end;
}
.export {
  padding: 10px;
}
.loading {
  text-align: center;
  background: #ffffff;
  border-radius: 4px;
  padding: 200px 50px;
  margin: 20px 0;
}
  #only-map{
    min-height: 800px;
  }
</style>
